import React from "react"
import SuitItem from "./SuitItem"

import imgBikini from "@images/suit-bikini.webp"
import imgSun from "@images/suit-sun.webp"
import imgPalm from "@images/suit-palm.webp"
import imgFlower from "@images/suit-flower.webp"

const SuitYourselfSection = ({ data, className = '', hideHeader = false, noPaddings = false }) => {
  return (
    <React.Fragment>
      <section className={`max-container mt-14 ${className}`}>
        {!hideHeader && (
          <section className="block text-center">
            <h1>Suit Yourself</h1>
            <p className="mt-2 mb-4">
              Every body is a bikini body, we love seeing you rock yours!
            </p>
          </section>
        )}
        
        <section className={`grid grid-cols-4 justify-center md:justify-between items-start gap-4 py-0 ${!noPaddings && 'md:py-24'}`}>
          <SuitItem
            image={imgBikini}
            title={"Every Body is a Bikini Body"}
            description={
              "Choose prints from floral, basics, tropical, retro, vintage themes and more in the most flattering styles. There’s something for everyone!"
            }
            buttonLabel={"Shop Now"}
            link={'/collections/all/'}
          />

          <SuitItem
            image={imgSun}
            title={"Loved by Over a Million Fans"}
            description={
              "With over 1M followers, 24,000+ 5-star reviews, and features in WWD, Vogue, and Elle, we're your go-to for high-quality, stylish swimwear that lasts."
            }
            buttonLabel={"See reviews"}
            link={'/blackbough-reviews/'}
          />

          <SuitItem
            image={imgPalm}
            title={"Mindfully Made"}
            description={
              "Choose sustainability without sacrificing style! 100% of our swimwear is crafted from recycled fabric and delivered to you in biodegradable packaging."
            }
            buttonLabel={"Our commitment"}
            link={'/our-commitment/'}
          />

          <SuitItem
            image={imgFlower}
            title={"Join Our Community"}
            description={
              "Unlock exclusive benefits with the Blackbough Beach Club! Enjoy discounts, rewards, and exciting prizes."
            }
            buttonLabel={<>
              <div className="block md:hidden">Blackbough<br/>Beach Club</div>
              <div className="hidden md:block">Blackbough Beach Club</div>
            </>}
            link={'/blackbough-beach-club/'}
          />
        </section>
      </section>
    </React.Fragment>
  );
};

export default SuitYourselfSection;
